export default __webpack_public_path__ + "static/media/SHARANAMMA.85f35427.JPG";